// extracted by mini-css-extract-plugin
module.exports = {"circle":"TextStatusReservation_circle__XeW8W"};